export default __webpack_public_path__ + "static/media/clear.806ddd0e.svg";